import classNames from 'classnames';
import { CSSProperties, useRef } from 'react';

import { SmallLibrary } from '@/components/icon';
import { MediaConfigType } from '@/const/richMedia';
import { UserResourceType } from '@/interface/library';
import { INewUploadIProps } from '@/interface/upload';
import { ISpineResult } from '@/material/form-upload/folder';
import LibraryDialog, { ILibraryDialogRef } from '@/pages/library/dialog';

import { emitRichMedia, emitRichMediaFile, getRichLocalPath } from '../../../change-data';
import styles from '../index.module.less';

const LibraryContent: React.FC<INewUploadIProps & {
  type?: UserResourceType;
  onSpineChange?: (result: ISpineResult) => void;
  libraryStyle?: CSSProperties;
}> = (props) => {
  const { value, disabled, onChange, type, onSpineChange } = props;

  const handleLibraryConfirm = (params: { url: string; name: string } | ISpineResult) => {
    if (type === UserResourceType.RESOURCE_TYPE_SPINE) {
      const { localPath, directoryPath } = params as ISpineResult;
      if (localPath && directoryPath) {
        emitRichMedia(localPath, directoryPath, MediaConfigType.SPINE);
      }
      onSpineChange?.(params as ISpineResult);
      return;
    }
    const { url, name } = params as { url: string; name: string };
    emitRichMediaFile(url);
    const localPath = getRichLocalPath(url);
    const result = {
      ...value,
      volume: 100,
      url: {
        ...value?.url,
        url,
        localPath,
        name,
      },
    };
    onChange?.(result);
  };

  const libraryRef = useRef<ILibraryDialogRef>(null);

  const openDialog = () => {
    if (disabled) return;
    libraryRef?.current?.open();
  };

  return (
    <>
      <div
        className={classNames(styles.item, {
          ['nova-disabled-opacity']: disabled,
          ['nova-disabled']: disabled,
        })}
        onClick={openDialog}
        style={props.libraryStyle}
      >
        <div className={styles.textWrap}>
          <SmallLibrary style={{ width: 18, height: 18 }} />
          <span>素材库</span>
        </div>
      </div>
      <LibraryDialog
        type={type}
        dialogRef={libraryRef}
        confirmCallback={handleLibraryConfirm}
      />
    </>
  );
};

export default LibraryContent;
